import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import immer from 'immer';
import { deepClone } from './clone';
export var getFilterTree = function getFilterTree(treeNodes, filterFunc, filterExpandKeys, keyFunc) {
  var childrenKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'children';
  var showHitDescendants = arguments.length > 5 ? arguments[5] : undefined;
  var firstMatchNode = arguments.length > 6 ? arguments[6] : undefined;

  var _ref = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {},
      advanced = _ref.advanced;

  var mapFilteredNodeToData = function mapFilteredNodeToData(node) {
    if (!node) return null;
    var match = false;

    if (filterFunc(node)) {
      if (firstMatchNode) firstMatchNode(node);
      match = true;
    }

    var children = (node[childrenKey] || []).map(mapFilteredNodeToData).filter(function (n) {
      return n;
    });

    if (children.length || match) {
      var key = keyFunc(node);
      if (filterExpandKeys && children.length > 0) filterExpandKeys.push(key);
      if (!node[childrenKey]) return node;
      var childNodes = showHitDescendants && match ? node[childrenKey] || [] : children;
      if (advanced && match && children.length > 0) childNodes = children;
      return _objectSpread2(_objectSpread2({}, node), {}, _defineProperty({}, childrenKey, childNodes));
    }

    return null;
  };

  return treeNodes.map(mapFilteredNodeToData).filter(function (node) {
    return node;
  });
};
export var getFlattenTree = function getFlattenTree(data) {
  var childrenKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
  var wide = arguments.length > 2 ? arguments[2] : undefined;
  var arr = [];

  var flatten = function flatten(list, path) {
    list.forEach(function (item) {
      var children = item[childrenKey];

      if (children && children.length > 0) {
        var clonedPath = _toConsumableArray(path);

        clonedPath.push(item);
        if (wide) arr.push(clonedPath);
        flatten(children, clonedPath);
      } else {
        arr.push([].concat(_toConsumableArray(path), [item]));
      }
    });
  };

  flatten(data, []);
  return arr;
};
export var mergeFilteredTree = function mergeFilteredTree(filterDatum, rawDatum, tiledId) {
  var filterData = filterDatum.data;
  var childrenKey = filterDatum.childrenKey;
  if (tiledId.length === 0) return filterData;

  var recursion = function recursion(node) {
    var nodeKey = filterDatum.getKey(node);

    if (tiledId.indexOf(nodeKey) >= 0) {
      node[childrenKey] = deepClone(rawDatum.getDataById(nodeKey)[childrenKey] || []);
    } else {
      var item = filterDatum.getDataById(nodeKey);

      if (item && item[childrenKey]) {
        node[childrenKey] = deepClone(item[childrenKey] || []);
      }
    }

    var children = node[childrenKey] || [];
    children.map(recursion);
  };

  return immer(filterData, function (draft) {
    draft.map(recursion);
  });
};